import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export const Premium = () => {
  const { t } = useLang();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="section-premium"
      className="relative py-24 lg:py-40 overflow-hidden"
      style={{
        background:
          "radial-gradient(circle at 30% 20%, rgba(227,0,15,0.15) 0%, rgba(0,0,0,0) 55%), radial-gradient(circle at 80% 80%, rgba(212,175,55,0.10) 0%, rgba(0,0,0,0) 50%), #050505",
      }}
    >
      <div className="grain absolute inset-0" />
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-5xl"
        >
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-gold" />
            <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-gold">
              {t("premium.eyebrow")}
            </span>
          </div>

          <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-[1.02] tracking-tight">
            {t("premium.title")}
          </h2>

          <p className="mt-8 font-body text-base lg:text-xl text-zinc-300 leading-relaxed max-w-3xl">
            {t("premium.p")}
          </p>

          <div className="gold-line my-12 max-w-md" />

          <button
            data-testid="premium-cta"
            onClick={() => scrollTo("kontakt")}
            className="group inline-flex items-center gap-4 border-b border-white/40 hover:border-primary-red pb-3 pr-2 transition-colors"
          >
            <span className="font-display text-xl lg:text-2xl font-semibold text-white group-hover:text-primary-red transition-colors">
              {t("premium.cta")}
            </span>
            <ArrowUpRight
              size={24}
              className="text-white group-hover:text-primary-red transition-all duration-500 group-hover:translate-x-1 group-hover:-translate-y-1"
            />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
